import { CsamSensorReadDTO, FacilityCode, ListOfValuesReadDTO, LocationDTO } from '../../api/dto';
import { LocationWithNodeDTO } from '../../api/locations';

export const isLeafLocation = (location: LocationWithNodeDTO): boolean => location.node.childCount === 0;

export const areLocationsEqual = (l1: LocationDTO, l2: LocationDTO): boolean => l1.id === l2.id;
export const areSensorsEqual = (l1: CsamSensorReadDTO, l2: CsamSensorReadDTO): boolean => l1.sensorId === l2.sensorId;

export const areLocationsPartOfFacility = ({
    facility,
    locations,
}: {
    facility: ListOfValuesReadDTO | null;
    locations: LocationDTO[];
}): boolean => locations?.every((location) => (location.facility?.code ?? FacilityCode.SURFACE) === facility?.code);
